import { render, staticRenderFns } from "./ArticuloAgregarEspecialComponent.vue?vue&type=template&id=680e5cc4"
import script from "./ArticuloAgregarEspecialComponent.vue?vue&type=script&lang=js"
export * from "./ArticuloAgregarEspecialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports